import { all, call, select } from 'redux-saga/effects';
import { API } from '../../api';

const getServerConfig = ({ serverConfig }) => serverConfig;

const getCensusTable = (report) => report.sections[0].properties.filter(
  ({ type }) => type === 'CENSUS_COMPARISON_TABLE',
).map(({ table }) => table);

export function* fetchCensusTable({ filterString, report }) {
  const serverConfig = yield select(getServerConfig);
  const tables = (getCensusTable(report) || {}) || ['census_table'];

  try {
    const chartData = yield all(
      tables.reduce((acc, table) => {
        const path = `/chart/${serverConfig.namespace}/${table}?${filterString}`;
        return {
          ...acc,
          [table]: call(API, 'get', 'api', path),
        };
      }, {}),
    );

    return tables.reduce((acc, table) => {
      return {
        ...acc,
        [table]: (chartData[table] || {}).data || [],
      };
    }, {});
  } catch (e) {
    console.error(e);
  }
  return {};
}
